import React from 'react';
import { Button } from '../components/Button';
export function NotFound() {
  return <section className="bg-mist py-32" data-id="element-436" data-mp="w3zwjvurcc1p">
      <div className="mx-auto max-w-2xl px-6 text-center" data-id="element-437" data-mp="w4t3awtpv1ju">
        <p className="text-sm font-medium text-gold-dark" data-id="element-438" data-mp="105d0u1i7c76i">Page not found</p>
        <h1 className="mt-4 font-serif text-5xl font-medium text-navy" data-id="element-439" data-mp="1087gzgu6n5u4">This page doesn’t exist.</h1>
        <p className="mt-6 text-lg text-ink/75" data-id="element-440" data-mp="1a427ey4ne57g">The link may be outdated, or the page may have moved.</p>
        <div className="mt-10 flex justify-center" data-id="element-441" data-mp="1f35d8ksgcfgh">
          <Button to="/" data-id="element-442" data-mp="1f1kj2wa1uyj5">Back to Home</Button>
        </div>
      </div>
    </section>;
}